export default __webpack_public_path__ + "static/media/cmft ios.b468c37c.png";